import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { Checkbox, PhaseOptionContainer } from './PhaseOption.style';

interface PhaseOptionProps {
  phaseLabel: any;
  isActive: boolean;
  isLabeled: boolean;
  handlePhaseOptionOnClick: () => void;
}

const PhaseOption = ({
  phaseLabel,
  isActive,
  isLabeled,
  handlePhaseOptionOnClick,
}: PhaseOptionProps) => {
  const hotkey = phaseLabel?.phaseClass?.[0];
  const label = phaseLabel?.phaseClass;

  useHotkeys(hotkey, event => {
    event?.preventDefault();
    handlePhaseOptionOnClick();
  });

  return (
    <PhaseOptionContainer isSelected={isActive} onClick={handlePhaseOptionOnClick}>
      <Checkbox checked={isLabeled} readOnly />({hotkey}) {label}
    </PhaseOptionContainer>
  );
};

export default PhaseOption;
